import { AuthService } from '../auth/auth.service';
import { IndicationDetailsStorageService } from '../services/indication-details-storage.service';
import { LoginDetailsStorageService } from '../services/login-details-storage.service';
import { PolicyDetailsStorageService } from '../services/policy-details-storage.service';
import { QuoteDetailsStorageService } from '../services/quote-details-storage.service';
import { SecureSessionStorageService } from '../services/secure-session-storage.service';
import { SessionBootstrapService } from '../services/session-bootstrap.service';
import { TempDetailsStorageService } from '../services/temp-details-storage.service';

export function initializeAppSession(
  secureSessionStorage: SecureSessionStorageService,
  loginDetailsStorage: LoginDetailsStorageService,
  tempDetailsStorage: TempDetailsStorageService,
  indicationDetailsStorage: IndicationDetailsStorageService,
  quoteDetailsStorage: QuoteDetailsStorageService,
  policyDetailsStorage: PolicyDetailsStorageService,
  authService: AuthService,
  sessionBootstrap: SessionBootstrapService
): () => Promise<void> {
  return async () => {
    if (typeof window === 'undefined') {
      return;
    }

    const onAuthPage = sessionBootstrap.isAuthRoute(
      sessionBootstrap.getBrowserPath()
    );

    if (!onAuthPage) {
      sessionBootstrap.beginRestore();
    }

    loginDetailsStorage.purgeNativeLoginKeysFromBrowser();
    tempDetailsStorage.purgeNativeTempKeysFromBrowser();
    indicationDetailsStorage.purgeNativeIndicationKeysFromBrowser();
    quoteDetailsStorage.purgeNativeQuoteKeysFromBrowser();
    policyDetailsStorage.purgeNativePolicyKeysFromBrowser();

    secureSessionStorage.init();
    loginDetailsStorage.initSessionStorageBridge();
    tempDetailsStorage.initSessionStorageBridge();
    indicationDetailsStorage.initSessionStorageBridge();
    quoteDetailsStorage.initSessionStorageBridge();
    policyDetailsStorage.initSessionStorageBridge();

    authService.migrateLegacyAuthCookiesToStorage();

    if (onAuthPage || !authService.hasRestorableSession()) {
      sessionBootstrap.completeStartup(0);
    }

    /* Cache GET restore runs in AppComponent on workflow routes only. */
  };
}
